export const AWARD_COLUMNS = [
    { id:'coverImageUrl', label: 'Cover', width: '6%', isImage: true },
    { id: 'title', label: 'Name', width: '24%'},
    { id: 'awardCategory', label: 'Category', width: '24%', isObj: true, child:'title'},
    { id: 'createdAt', label: 'Created Date', width: '24%', isDate: true},
    { id: 'published', label: 'Published', width: '7%', isList: true, list: [true, false], clickable: true},
    { id: 'actions', width: '15%' },
];